import React, { useEffect } from 'react';
import { Heading, Button, Pecten, Sizes } from '@sede-enterprise/shell-ds-react-framework';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { userRoleActions } from '../../store/reducers/GenesisUser';
import routepaths from '../../router/routepaths';
import { AuthWrapper } from './style';

const MESSAGES = {
  M1: 'You are logged out',
  M2: 'Your session has expired. Please log in again to continue...',
  M3: 'The web app you have attempted to reach has blocked your access(CORS), Please contact to system administrator',
  M4: 'Something went wrong please contact to system administrator',
  M5: "You don't have permission to access this application, Please contact to system administrator",
  M6: 'You are not Authorized to access this application. Please contact system administrator for access',
};

interface ILogout {
  messageKey: 'M1' | 'M2' | 'M3' | 'M4' | 'M5' | 'M6';
}
const Logout: React.FC<ILogout> = ({ messageKey }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    sessionStorage.clear();
    dispatch(userRoleActions.logOut());
  }, [dispatch]);
  const logIn = () => {
    navigate(routepaths.login);
  };

  return (
    <AuthWrapper>
      <Pecten size={Sizes.Large} />
      <h1 className='title'>Genesis</h1>
      <Heading className='logged-out' type='h1'>
        {MESSAGES[messageKey]}
      </Heading>
      {(messageKey === 'M1' || messageKey === 'M2') && (
        <Button className='btn-logged_out' size='medium' onClick={logIn}>
          Log In
        </Button>
      )}
    </AuthWrapper>
  );
};

export default Logout;
